<section>
  <div class="row">
    <form [formGroup]="formPrintingRange" class="container-style">
      <div class="row">
        <p>Ingrese el rango de Recibos a imprimir.</p>
      </div>
      <div class="row mb-2">
        <div class="col">
          <app-custom-input-number formControlName="consecutiveInitial" [labelText]="'Recibo Inicial'"
            [required]="true"></app-custom-input-number>
        </div>
        <div class="col">
          <app-custom-input-number formControlName="consecutiveFinal" [labelText]="'Recibo Final'"
            [required]="true"></app-custom-input-number>
        </div>
        <div class="col d-flex align-items-end">
          <app-custom-button [title]="'Guardar'" [label]="'Imprimir'" [variant]="undefined"
            (onClick)="close(true)"></app-custom-button>
        </div>
      </div>
    </form>
  </div>
  <div class="row pt-3">
    <div class="col d-flex justify-content-end">
      <app-custom-button [title]="'Salir'" [label]="'Salir'" [severity]="'danger'"
        (onClick)="close(false)"></app-custom-button>
    </div>
  </div>
</section>